export default __webpack_public_path__ + "static/media/Inbond_D.31a95ca0.svg";